<template>
    <secondary-button
        class="py-1 text-sm normal-case" @click="$emit('click', $event)"
        :is-active="isActive"
        :class="[tourClass]"
    >
        <slot/>
    </secondary-button>
</template>

<script>
    import SecondaryButton from './SecondaryButton.vue';

    export default {
        components: {
            SecondaryButton,
        },
        props: {
            tourClass: String,
            isActive: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>